import React, { useEffect, useState } from "react";
import { Modal, Form, Container, Col, Row } from "react-bootstrap";
import { useAssignJobMutation, useDeleteJobMutation, useGetAllUsersQuery } from "../../store";
import {
  CustomTable,
  DeleteButton,
  LoadingBox,
  MessageBox,
  MotionDiv,
  useTitle,
  ViewButton,
} from "../../components";
import { useGetAllJobsQuery } from "../../store";
import { redirect, useNavigate } from "react-router-dom";
import { ImCross } from "react-icons/im";
import { FaCheck, FaUserPlus, FaUserTimes } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { ChatButton } from "../../components/layout/CustomTable";
import { ConfirmationModal, DateInput, SelectInput } from "../../components/layout/CustomForm";
import { toast, ToastContainer } from "react-toastify";
import { toastOptions } from "../../utils/error";
// import AssignJobModal from "./AssignJobModal"; // Import the new AssignJobModal component

const column = [
  "Sr No.",
  "File No.",
  "Intended User",
  "Payment Status",
  "Job Status",
  "Price",
  "Expired",
  "Job Assigned",
  "Rush Request",
  "Assigned Appraiser",
  "Actions",
];

const AssignJobModal = ({ show, onHide, job, getAllJobs }) => {
  const { isLoading, isError, data, error, endpointName, refetch } =
    useGetAllUsersQuery();
  const lastAssignedAppraiserIndex = job?.assigned_appraiser?.length - 1;

  const [appraiserId, setAppraiserId] = useState(
    job?.assigned_appraiser[lastAssignedAppraiserIndex]?.appraiser?.id || ""
  );
  const [assignJob, { isLoading: isAssignLoading }] = useAssignJobMutation();

  const handleAssign = async () => {
    console.log(appraiserId, job.id);
    try {
      const response = await assignJob({ id: job.id, userId: appraiserId });
      if (response.error && !response.error.data.success) {
        toast.error(response.error?.data?.message, toastOptions);
        onHide();
        return;
      }

      toast.success("Appraiser assigned successfully", toastOptions);
      onHide();
      getAllJobs();
    } catch (error) {
      toast.error(error.message);
      console.error("Failed to assign job:", error);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {job?.isAssigned ? "Reassign Appraiser" : "Assign Appraiser"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="appraiserSelect">
          <Form.Label>Select Appraiser</Form.Label>
          <Form.Control
            as="select"
            value={appraiserId}
            onChange={(e) => setAppraiserId(e.target.value)}
          >
            {/* Default option */}
            <option disabled={true} value="">
              Select an active Appraiser
            </option>

            {/* Filter available users */}
            {data?.users &&
              data.users.filter((user) => user.available).length > 0 ? (
              data.users
                .filter((user) => user.available)
                .map((user) => (
                  <option value={user.id} key={user.id}>
                    {user.name}
                  </option>
                ))
            ) : (
              <option disabled={true} value="">
                No active Appraisers
              </option>
            )}
          </Form.Control>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          disabled={!appraiserId}
          variant="primary"
          onClick={handleAssign}
        >
          {job?.isAssigned ? "Reassign" : "Assign"}
          {isAssignLoading && (
            <LoadingBox style={{ height: "1rem", width: "1rem" }} />
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const JobManagement = () => {
  useTitle("Jobs Management");

  const [currentPage, setCurrentPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(10);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [jobId, setJobId] = useState("");
  const [job, setJob] = useState(null);
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    job_status: "", // For example: "Assigned", "Not Assigned"
    from: "",
    to: "",
  });

  const { isLoading, isFetching, isError, data, error, refetch } =
    useGetAllJobsQuery({
      page: currentPage,
      limit: resultPerPage,
      ...filters,
    });

  const [deleteJob, { isLoading: isDeleteLoading, isSuccess: isDeleteSuccess, isError: isDeleteError }] = useDeleteJobMutation()

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters((prev) => ({
      job_status: "", // For example: "Assigned", "Not Assigned"
      from: "",
      to: "",
    }));
  };

  console.log("Data: ", data);

  const pageHandler = (p) => {
    setCurrentPage(p);
  };

  const handleAssignJob = (job) => {
    setJob(job);
    setShowAssignModal(true);
  };

  const handleDelete = (id) => {
    setJobId(id);
    setShowConfirmationModal(true);
  };

  const handleOnHide = () => {
    setShowConfirmationModal(false)
  }

  const deleteHandler = async (e) => {
    e.preventDefault();
    await deleteJob(jobId);
  };

  useEffect(() => {
    if (data) {
      setJobs(data?.jobs);
    }
  }, [data]);

  useEffect(() => {
    if (isDeleteSuccess) {
      refetch()
    }
  }, [isDeleteSuccess])

  return (
    <>
      <MotionDiv>
        {isError ? (
          <MessageBox variant="danger">
            {error?.data?.error?.message}
          </MessageBox>
        ) : (
          <>
            {/* Filters Section */}
            <Container>
              <Row className="filters">
                <Col md="3">
                  <SelectInput
                    label="Job status"
                    name="job_status"
                    value={filters.job_status}
                    options={[
                      { active: "Active" },
                      { accepted: "Accepted" },
                      { client_visit: "Client Visit" },
                      { post_visit_summary: "Post Visit Summary" },
                      { site_visit_scheduled: "Site Visit Scheduled" },
                      { completed: "Completed" },
                      { cancelled: "Cancelled" },
                    ]}
                    onChange={handleFilterChange}
                  />
                </Col>
                <Col md="3">
                  <DateInput
                    label="From"
                    name="from"
                    value={filters.from}
                    onChange={handleFilterChange}
                  />
                </Col>
                <Col md="3">
                  <DateInput
                    label="To"
                    name="to"
                    value={filters.to}
                    onChange={handleFilterChange}
                  />
                </Col>

                <Col md="3">
                  <Button onClick={clearFilters}>Clear Filters</Button>
                </Col>
              </Row>
            </Container>
            <CustomTable
              loading={isFetching}
              column={column}
              rowNo={resultPerPage}
              rowProps={{ setResultPerPage }}
              paging={true}
              pageProps={{
                numOfPages: data?.totalPages,
                curPage: currentPage,
              }}
              pageHandler={pageHandler}
            >
              {jobs.length > 0 ? (
                jobs.map((job, i) => (
                  <tr key={job.id} className="odd">
                    <td className="text-center">
                      {(currentPage - 1) * resultPerPage + i + 1}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      {job.id}
                    </td><td style={{ textTransform: "capitalize" }}>
                      {job.intended_user}
                    </td>
                    <td className="text-center">
                      <span
                        className={`badge ${job.payment_status === "Pending"
                          ? "bg-warning text-dark"
                          : job.payment_status === "Completed"
                            ? "bg-success"
                            : job.payment_status === "Failed"
                              ? "bg-danger"
                              : "bg-secondary"
                          }`}
                      >
                        {job.payment_status}
                      </span>
                    </td>
                    <td style={{ textTransform: "capitalize" }}>{job.job_status}</td>
                    <td>${job.price}</td>
                    <td className="text-center">
                      {new Date(job.expires_at) > new Date() ? (
                        <ImCross className="red" />
                      ) : (
                        <FaCheck className="green" />
                      )}
                    </td>

                    {/* <td>{new Date(job.preferred_date).toLocaleDateString()}</td> */}
                    <td className="text-center">
                      {job.assigned_appraiser.length > 0 ? (
                        <FaCheck className="green" />
                      ) : (
                        <ImCross className="red" />
                      )}
                    </td>
                    <td className="text-center">
                      {Boolean(job.is_rush_req) ? (
                        <FaCheck className="green" />
                      ) : (
                        <ImCross className="red" />
                      )}
                    </td>
                    <td className="text-center">
                      {job?.assigned_appraiser[0]?.appraiser.name ||
                        "Not Assigned"}
                    </td>
                    <td className="text-center">
                      <ChatButton
                        disabled={job.job_status !== 'accepted'}
                        onClick={() => navigate(`/admin/chat/${job.id}`)}
                      />
                      <ViewButton
                        onClick={() => navigate(`/admin/jobs/view/${job.id}`)}
                      />
                      <Button
                        variant="secondary"
                        onClick={() => handleAssignJob(job)}
                        className="ms-2"
                        disabled={job.assigned_appraiser.length > 0 || (job.payment_status === 'Pending' || job.payment_status === 'Failed')}
                      >
                        <FaUserPlus /> Assign
                      </Button>
                      <DeleteButton disabled={job.assigned_appraiser.length > 0 || job.payment_status === 'Completed'} onClick={() => handleDelete(job.id)} />
                      {/* <DeleteButton /> */}
                    </td>
                  </tr>
                ))) : (
                <tr>
                  <td colSpan={12} className="text-center">
                    No Data Found!
                  </td>
                </tr>
              )}
              {/* Delete Job */}
              <ConfirmationModal
                show={showConfirmationModal}
                onHide={handleOnHide}
                title="Delete Job"
                body="Do you really want to delete this Job ?"
                successMessage="Job Deleted Successfully!"
                submitHandler={deleteHandler}
                reducerProps={{
                  loading: isDeleteLoading,
                  success: isDeleteSuccess,
                  error: isDeleteError,
                }}
              ></ConfirmationModal>

              {/* Assign job modal */}
              <AssignJobModal
                show={showAssignModal}
                onHide={() => setShowAssignModal(false)}
                job={job}
                getAllJobs={refetch}
              />
            </CustomTable>
          </>
        )}
      </MotionDiv>
      <ToastContainer />
    </>
  );
};

export default JobManagement;
